const images = {
	"logo": require("./logo.png"),
	"pdf": require("./pdf.png"),
	"info": require("./info.png"),
	"header-greenbar": require("./header-greenbar-mobile.jpg"),
	"checked-icon": require("./checked-icon.png"),
};

export default images;
